export const editableFieldsList = ['boughtClicks', 'soldClicks'];
export const fieldNameDropDown = ['adGroupName'];
export const dropDownMenuUrls = [
    {
        'label': 'Selling Partner Report',
        'link': 'SellingPartnersReport',
        'paramsList': [
            'siteId',
            'sourceId',
            'campaignName',
            'adGroupName'
        ],
        'commonParamsList': [
            'dateStartB',
            'dateEndB',
            'datesComparison',
            'groupByDate'
        ]
    },
    {
        'label': 'Hourly',
        'link': ''
    },
    {
        'label': 'History',
        'link': ''
    },
    {
        'label': 'Landing Page',
        'link': ''
    },
    {
        'label': 'Target Link',
        'link': ''
    },
    {
        'label': 'Keyword Rotation',
        'link': ''
    },
    {
        'label': 'Advertisers',
        'link': ''
    },
    {
        'label': 'Search Query Report',
        'link': '',
        'paramsList': [
            'siteId',
            'sourceId',
            'campaignName',
            'adGroupName'
        ],
        'commonParamsList': [
            'dateStartB',
            'dateEndB',
            'datesComparison',
            'groupByDate'
        ]
    }
];
export const reportColumnsDefinitions = [
    {
        label: 'Date',
        field: 'date',
        sign: null,
        width: '120px',
        classes: 'date-column',
        filter: true,
        sort: true,
        format: {
            type: 'string'
        },
        checked: false,
        visible: false,
        canBeFixed: true,
        isMetricValue: false,
        isCompareColumn: false,
        isDateComparisonComparableColumn: false
    },
    {
        label: 'Site Name',
        field: 'siteName',
        sign: null,
        width: '120px',
        classes: 'site-column',
        filter: true,
        sort: true,
        format: {
            type: 'string'
        },
        checked: true,
        visible: true,
        canBeFixed: true,
        isMetricValue: false,
        isCompareColumn: false,
        isDateComparisonComparableColumn: false
    },
    {
        label: 'Source',
        field: 'sourceName',
        sign: null,
        width: '100px',
        classes: 'source-column',
        filter: true,
        sort: true,
        format: {
            type: 'string'
        },
        checked: true,
        visible: true,
        canBeFixed: true,
        isMetricValue: false,
        isCompareColumn: false,
        isDateComparisonComparableColumn: false
    },
    {
        label: 'Campaign',
        field: 'campaignName',
        sign: null,
        width: '120px',
        classes: 'campaign-column',
        filter: true,
        sort: true,
        format: {
            type: 'string'
        },
        checked: true,
        visible: true,
        canBeFixed: true,
        isMetricValue: false,
        isCompareColumn: false,
        isDateComparisonComparableColumn: false
    },
    {
        label: 'AdGroup',
        field: 'adGroupName',
        sign: null,
        width: '120px',
        classes: 'adgroup-column',
        filter: true,
        sort: true,
        format: {
            type: 'string'
        },
        checked: true,
        visible: true,
        canBeFixed: true,
        isMetricValue: false,
        isCompareColumn: false,
        isDateComparisonComparableColumn: false
    },
    {
        label: 'Bought',
        field: 'boughtClicks',
        sign: null,
        width: '100px',
        classes: 'bought-clicks-column',
        filter: true,
        sort: true,
        format: {
            type: 'integer'
        },
        checked: true,
        visible: true,
        canBeFixed: true,
        isMetricValue: true,
        isDateComparisonComparableColumn: true
    },
    {
        label: 'AdCTR',
        field: 'adCtr',
        sign: '%',
        width: '120px',
        classes: 'adctr-clicks-column',
        filter: true,
        sort: true,
        format: {
            type: 'percentage',
            precision: 2
        },
        checked: true,
        visible: true,
        canBeFixed: true,
        isMetricValue: true,
        isCompareColumn: false,
        isDateComparisonComparableColumn: true
    },
    {
        label: 'Cost',
        field: 'cost',
        sign: '$',
        width: '100px',
        classes: 'cost-clicks-column',
        filter: true,
        sort: true,
        format: {
            type: 'float',
            precision: 2
        },
        checked: true,
        visible: true,
        canBeFixed: true,
        isMetricValue: true,
        isCompareColumn: false,
        isDateComparisonComparableColumn: true
    },
    {
        label: 'CPC',
        field: 'cpc',
        sign: '$',
        width: '100px',
        classes: 'cpc-clicks-column',
        filter: true,
        sort: true,
        format: {
            type: 'currency',
            precision: 2,
            currency: 'USD'
        },
        checked: true,
        visible: true,
        canBeFixed: true,
        isMetricValue: true,
        isCompareColumn: false,
        isDateComparisonComparableColumn: true
    },
    {
        label: 'CPA',
        field: 'cpa',
        sign: '$',
        width: '100px',
        classes: 'cpa-clicks-column',
        filter: true,
        sort: true,
        format: {
            type: 'currency',
            precision: 2,
            currency: 'USD'
        },
        checked: true,
        visible: true,
        canBeFixed: true,
        isMetricValue: true,
        isCompareColumn: false,
        isDateComparisonComparableColumn: true
    },
    {
        label: 'Avg Pos',
        field: 'avgPos',
        sign: null,
        width: '100px',
        classes: 'sold-clicks-column',
        filter: true,
        sort: true,
        format: {
            type: 'integer'
        },
        checked: true,
        visible: true,
        canBeFixed: true,
        isMetricValue: true,
        isCompareColumn: false,
        isDateComparisonComparableColumn: true
    },
    {
        label: 'Max CPC',
        field: 'maxCpc',
        sign: '$',
        width: '100px',
        classes: 'cpc-clicks-column',
        filter: true,
        sort: true,
        format: {
            type: 'currency',
            precision: 2,
            currency: 'USD'
        },
        checked: true,
        visible: true,
        canBeFixed: true,
        isMetricValue: false,
        isCompareColumn: false,
        isDateComparisonComparableColumn: true
    },
    {
        label: 'Max CPA',
        field: 'maxCpa',
        sign: '$',
        width: '100px',
        classes: 'cpc-clicks-column',
        filter: true,
        sort: true,
        format: {
            type: 'currency',
            precision: 2,
            currency: 'USD'
        },
        checked: true,
        visible: true,
        canBeFixed: true,
        isMetricValue: false,
        isCompareColumn: false,
        isDateComparisonComparableColumn: true
    },
    {
        label: 'Sold',
        field: 'soldClicks',
        sign: null,
        width: '100px',
        classes: 'sold-clicks-column',
        filter: true,
        sort: true,
        format: {
            type: 'integer'
        },
        checked: true,
        visible: true,
        canBeFixed: true,
        isMetricValue: true,
        isCompareColumn: false,
        isDateComparisonComparableColumn: true
    },
    {
        label: 'Earned',
        field: 'revenue',
        sign: '$',
        width: '120px',
        classes: 'revenue-clicks-column',
        filter: true,
        sort: true,
        format: {
            type: 'currency',
            precision: 2,
            currency: 'USD'
        },
        checked: true,
        visible: true,
        canBeFixed: true,
        isMetricValue: true,
        isCompareColumn: false,
        isDateComparisonComparableColumn: true
    },
    {
        label: 'opCTR',
        field: 'opCtr',
        sign: '%',
        width: '120px',
        classes: 'opctr-clicks-column',
        filter: true,
        sort: true,
        format: {
            type: 'percentage',
            precision: 2
        },
        checked: true,
        visible: true,
        canBeFixed: true,
        isMetricValue: true,
        isCompareColumn: false,
        isDateComparisonComparableColumn: true
    },
    {
        label: 'RPS',
        field: 'rps',
        sign: '$',
        width: '100px',
        classes: 'rps-clicks-column',
        filter: true,
        sort: true,
        format: {
            type: 'currency',
            precision: 2,
            currency: 'USD'
        },
        checked: true,
        visible: true,
        canBeFixed: true,
        isMetricValue: true,
        isCompareColumn: false,
        isDateComparisonComparableColumn: true
    },
    {
        label: 'RPC',
        field: 'rpc',
        sign: '$',
        width: '100px',
        classes: 'rpc-clicks-column',
        filter: true,
        sort: true,
        format: {
            type: 'currency',
            precision: 2,
            currency: 'USD'
        },
        checked: true,
        visible: true,
        canBeFixed: true,
        isMetricValue: true,
        isCompareColumn: false,
        isDateComparisonComparableColumn: true
    },
    {
        label: 'Profit',
        field: 'profit',
        sign: '$',
        width: '100px',
        classes: 'profit-clicks-column',
        filter: true,
        sort: true,
        format: {
            type: 'currency',
            precision: 2,
            currency: 'USD'
        },
        checked: true,
        visible: true,
        canBeFixed: true,
        isMetricValue: true,
        isCompareColumn: false,
        isDateComparisonComparableColumn: true
    },
    {
        label: 'Margin',
        field: 'margin',
        sign: null,
        width: '100px',
        classes: 'margin-clicks-column',
        filter: true,
        sort: true,
        format: {
            type: 'percentage',
            precision: 2
        },
        checked: true,
        visible: true,
        canBeFixed: true,
        isMetricValue: true,
        isCompareColumn: false,
        isDateComparisonComparableColumn: true
    },
    {
        label: 'TQ',
        field: 'tq',
        sign: null,
        width: '100px',
        classes: 'tq-clicks-column',
        filter: true,
        sort: true,
        format: {
            type: 'float',
            precision: 2
        },
        checked: true,
        visible: true,
        canBeFixed: true,
        isMetricValue: true,
        isCompareColumn: false,
        isDateComparisonComparableColumn: true
    },
    {
        label: 'Scrub',
        field: 'scrubRate',
        sign: '%',
        width: '100px',
        classes: 'scrub-clicks-column',
        filter: true,
        sort: true,
        format: {
            type: 'percentage',
            precision: 2
        },
        checked: true,
        visible: true,
        canBeFixed: true,
        isMetricValue: true,
        isCompareColumn: false,
        isDateComparisonComparableColumn: true
    },
    {
        label: 'Conv',
        field: 'conversions',
        sign: null,
        width: '100px',
        classes: 'conversions-clicks-column',
        filter: true,
        sort: true,
        format: {
            type: "integer"
        },
        checked: true,
        visible: true,
        canBeFixed: true,
        isMetricValue: true,
        isCompareColumn: false,
        isDateComparisonComparableColumn: true
    },
    {
        label: 'Label',
        field: 'adGroupLabels',
        sign: null,
        width: '100px',
        classes: 'sold-clicks-column',
        filter: true,
        sort: true,
        format: {
            type: 'array'
        },
        checked: true,
        visible: true,
        canBeFixed: true,
        isMetricValue: false,
        isCompareColumn: false,
        isDateComparisonComparableColumn: false
    },
    {
        label: 'Status',
        field: 'adGroupStatus',
        sign: null,
        width: '100px',
        classes: 'sold-clicks-column',
        filter: true,
        sort: true,
        format: {
            type: 'custom'
        },
        virtualField: true,
        checked: true,
        visible: true,
        canBeFixed: true,
        isMetricValue: false,
        isCompareColumn: false,
        isDateComparisonComparableColumn: false
    },
    {
        label: 'KWR num',
        field: 'kwrNum',
        sign: null,
        width: '100px',
        classes: 'kwr-num-clicks-column',
        filter: true,
        sort: true,
        format: {
            type: 'integer'
        },
        virtualField: false,
        checked: true,
        visible: true,
        canBeFixed: true,
        isMetricValue: false,
        isCompareColumn: false,
        isDateComparisonComparableColumn: false
    }
];



// WEBPACK FOOTER //
// ./src/configs/adgroup-report-config.js